const API = "/api/noticias";

export async function getNoticias(siteId) {

  const res = await fetch(`${API}?cliente_id=${siteId}`);

  if (!res.ok) {
    throw new Error("Erro ao buscar banners");
  }

  return res.json();
}